import { render } from "./AddonFields.vue?vue&type=template&id=573ca9ac&scoped=true"
import script from "./AddonFields.vue?vue&type=script&lang=js"
export * from "./AddonFields.vue?vue&type=script&lang=js"

import "./AddonFields.vue?vue&type=style&index=0&id=573ca9ac&lang=scss&scoped=true"

import exportComponent from "/Users/marcobrito/Documents/projects/backoffice/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-573ca9ac"]])

export default __exports__